import { DashboardGreeting } from "@/features/dashboard/components/DashboardGreeting"
import { KpiSection } from "@/features/dashboard/components/KpiSection"
import { QuickAccessSection } from "@/features/dashboard/components/QuickAccessSection"
import { RecentActivitySection } from "@/features/dashboard/components/RecentActivitySection"
import { MyTasksKanbanWidget } from "@/features/tasks/components/MyTasksKanbanWidget"

export function DashboardPage() {
  return (
    <div className="flex flex-col gap-8">
      <DashboardGreeting />
      <KpiSection />
      <div className="rounded-lg border border-slate-200 bg-white overflow-hidden">
        <MyTasksKanbanWidget />
      </div>
      <QuickAccessSection />
      <RecentActivitySection />
    </div>
  )
}
